import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
  excludedIpSlug: string;
};

export const ExcludedIPEditPage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, siteSlug, excludedIpSlug }) => {
  const breadcrumbs = useMemo(
    () => [
      { label: "設定", path: `/sites/${siteSlug}/settings` },
      {
        label: "除外IP編集",
        path: `/sites/${siteSlug}/excluded_ips/${excludedIpSlug}/edit`,
      },
    ],
    [excludedIpSlug, siteSlug]
  );

  return (
    <PageLayout title="除外IP編集" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
